<template>
  <CCard>
    <CCardHeader>
      <h2>クライアント詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
      <div v-if="loading" class="d-flex align-items-center py-4">
        <CSpinner color="primary" class="mr-2"/>
        <span>クライアント情報を読み込んでいます。</span>
      </div>
      <template v-else-if="items">
        <CRow>
          <CCol sm="6">
            <table class="table">
              <tr><th nowrap>取引先企業名</th><td>{{ items.company_name }}</td></tr>
              <tr><th nowrap>取引先担当者名</th><td>{{ items.staff_name }}</td></tr>
              <tr><th nowrap>電話番号</th><td>{{ items.telephone }}</td></tr>
              <tr><th nowrap>住所</th><td>{{ items.address }}</td></tr>
              <tr><th nowrap>E-Mail</th><td>{{ items.email }}</td></tr>
              <tr><th nowrap>支払いサイト</th><td>{{ items.usance }}<template v-if="items.usance !== null && items.usance !== undefined">(日)</template></td></tr>
              <tr><th nowrap>備考</th><td>{{ items.remarks }}</td></tr>
            </table>
          </CCol>
        </CRow>
        <CRow class="mt-3 align-items-center">
          <CCol class="text-start">
            <router-link :to="{ name: clientList }">
              <button class="btn btn-secondary">戻る</button>
            </router-link>
          </CCol>
          <CCol class="text-center">
            <router-link :to="editRoute">
              <button class="btn btn-info">編集</button>
            </router-link>
          </CCol>
          <CCol></CCol>
        </CRow>
      </template>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from 'axios'
import ConstList from './../ConstList'
import { recordQueryRoute, resolveRouteRecordId } from '@/common/routeRecordId'
import { safeErrorDigest } from '../utils/safeResponseMessage'

export default {
  name: 'ClientInfo',
  data () {
    return {
      items: null,
      clientId: null,
      clientList: ConstList.ROUTE_CLIENT_LIST,
      clientUpdate: ConstList.ROUTE_CLIENT_UPDATE,
      loading: false,
      errorMessage: ''
    }
  },
  computed: {
    editRoute () {
      return this.clientId
        ? recordQueryRoute(this.clientUpdate, this.clientId)
        : { name: this.clientList }
    }
  },
  watch: {
    '$route.fullPath': 'loadClient'
  },
  mounted () {
    this.loadClient()
  },
  methods: {
    async loadClient () {
      this.errorMessage = ''
      this.items = null
      this.clientId = resolveRouteRecordId(this.$route)
      if (!this.clientId) {
        this.errorMessage = 'クライアントを特定できません。一覧から選択し直してください。'
        return
      }

      this.loading = true
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_ORIGIN}/clients/${this.clientId}`
        )
        this.items = response.data || null
        if (!this.items) this.errorMessage = 'クライアントが見つかりません。'
      } catch (error) {
        this.errorMessage = 'クライアント情報を取得できませんでした。'
        console.error('クライアント詳細取得失敗:', safeErrorDigest(error))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
